import { useState, useEffect, createContext } from "react";
import { createNewBlogPost, getAllBlogs } from "./blogpost.services";

export const BlogPostContext = createContext();

export const BlogPostContextProvider = ({ children }) => {

    const [blogposts, setBloposts] = useState([]);
    const [isLoading, setIsLoading] = useState();

    /** create new blogpost */
    const createNewBlog = async (data, token) => {
        try {
            setIsLoading(true);
            const response = await createNewBlogPost(data, token);
            const res = await response.text();
            setIsLoading(false);
            return res;
        } catch (error) {
            setIsLoading(false);
            console.log({ error });
        }
    }

    useEffect(() => {
        /** get all blogs */
        const getAllBlogPosts = async () => {
            try {
                const response = await getAllBlogs();
                const res = await response.json();
                return res;
            } catch (error) {
                console.log({ error });
            }
        }
        ( async() => {
           const data = await getAllBlogPosts();
           setBloposts(data);
           console.log({data});
        })();
    }, [])



    return (
        <BlogPostContext.Provider
            value={{
                blogposts,
                isLoading,
                createNewBlog,
            }}
        >
            {children}
        </BlogPostContext.Provider>
    )
}

export const useBlogPost = () => BlogPostContext;